<template>
  <div>deliveryPeriodEnd</div>
</template>
<script>
export default {
  name: 'deliveryPeriodEnd',
}
</script>
